import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Tooltip from "@mui/material/Tooltip";

export default function AlertDialog(props) {
  const { validerroropen, setvaliderroropen } = props;

  const handleClose = () => {
    setvaliderroropen(false);
  };

  return (
    <div>
      <Dialog
        open={validerroropen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <WarningRoundedIcon style={{ color: "tomato" }} /> {"  "}{" "}
          <large>{"  "}Invalid Date and Time!</large>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select the appropriate Date and Time. The end time shouldn't come before (start) the time.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleClose} color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
}
